import PageHeader from "@/components/layout/PageHeader";
import StatsRow from "@/components/sections/StatsRow";
import WhyChooseUs from "@/components/sections/WhyChooseUs";
import Testimonials from "@/components/sections/Testimonials";
import ContactBlock from "@/components/sections/ContactBlock";

export default function AboutPage() {
  return (
    <div data-testid="about-page">
      <PageHeader
        overline="About"
        title="A trusted partner for construction, comfort and care."
        sub="ME Builders is a trusted construction and home service company proudly serving Los Angeles and surrounding communities. We provide residential and light commercial solutions with a focus on professionalism, efficiency and quality workmanship."
        image="https://images.pexels.com/photos/8482551/pexels-photo-8482551.jpeg"
        breadcrumbs={[{ label: "Home", to: "/" }, { label: "About" }]}
      />

      <StatsRow />

      <section className="section-pad">
        <div className="container-page grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <p className="overline mb-3">Our mission</p>
            <h2 className="heading-2">Quality work, honest service, long-lasting results.</h2>
          </div>
          <div className="md:col-span-7 space-y-5">
            <p className="body-base">
              Our company was built on reliability, clean craftsmanship and customer satisfaction. We understand that every project matters — whether it's a simple plumbing repair, HVAC maintenance, or a complete ADU build from the ground up.
            </p>
            <p className="body-base">
              From the first conversation to the final walkthrough, we work to make construction feel calm, organized and predictable — for residential and light commercial projects across {`Los Angeles`}.
            </p>
          </div>
        </div>
      </section>

      <WhyChooseUs />
      <Testimonials />
      <ContactBlock source="about_page" />
    </div>
  );
}
